import { FastColor } from '@ant-design/fast-color'
import { createStyles } from 'antd-style'

const BORDER_OVERLAY_ALPHA = 0.18
const DISABLED_ALPHA = 0.35

const HOVER_FILL_ALPHA = 0.13
const ACTIVE_FILL_ALPHA = 0.2

const OVERFLOW_MENU_MIN_WIDTH = 184
const PANEL_POPOVER_PADDING = 8

export const useStyles = createStyles(({ token }) => {
  const onDark = token.colorTextLightSolid

  const hoverBg = new FastColor(onDark).setA(HOVER_FILL_ALPHA).toRgbString()
  const activeBg = new FastColor(onDark).setA(ACTIVE_FILL_ALPHA).toRgbString()

  const lineColor = new FastColor(onDark)
    .setA(BORDER_OVERLAY_ALPHA)
    .toRgbString()

  return {
    bar: {
      position: 'relative',
      flexShrink: 0,
      minWidth: 0,
      pointerEvents: 'auto',
      padding: `${token.paddingXXS}px ${token.paddingSM}px`,
      backgroundColor: token.colorBgSpotlight,
      border: `${token.lineWidth}px ${token.lineType} ${lineColor}`,
      borderRadius: token.borderRadiusLG,
      boxShadow: token.boxShadowSecondary,
      color: onDark
    },

    selectAllSlot: {
      '.ant-btn': {
        color: `${onDark} !important`
      },

      '.ant-btn:hover, .ant-btn:focus-visible': {
        backgroundColor: `${hoverBg} !important`
      },

      '.ant-btn:active': {
        backgroundColor: `${activeBg} !important`
      }
    },

    actions: {
      minWidth: 0
    },

    measureClip: {
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden',
      visibility: 'hidden',
      pointerEvents: 'none'
    },

    measureRow: {
      display: 'flex',
      width: 'max-content',
      whiteSpace: 'nowrap'
    },

    label: {
      whiteSpace: 'nowrap',
      fontWeight: token.fontWeightStrong,
      fontVariantNumeric: 'tabular-nums'
    },

    selectionButton: {
      height: 'auto',
      paddingBlock: token.paddingXXS,
      paddingInline: token.paddingXS
    },

    divider: {
      borderInlineStartColor: lineColor,
      margin: 0,
      height: 'calc(100% - 8px)'
    },

    summaryButton: {
      border: `1px solid ${activeBg} !important`,
      paddingBlock: token.padding,
      paddingInline: token.paddingXS
    },

    actionButton: {
      '&&:hover, &&:focus-visible': {
        backgroundColor: `${hoverBg} !important`
      },

      '&&:active': {
        backgroundColor: `${activeBg} !important`
      },

      '&&:disabled': {
        color: new FastColor(onDark).setA(DISABLED_ALPHA).toRgbString()
      },

      '&:not(.ant-btn-dangerous)': {
        color: onDark,

        '&&:hover, &&:focus-visible': {
          color: `${onDark} !important`
        },

        '&&:active': {
          color: `${onDark} !important`
        }
      }
    },

    flushPopover: {
      '&&&': {
        padding: 0
      }
    },

    compactPopover: {
      '&&&': {
        padding: PANEL_POPOVER_PADDING
      }
    },

    flushPanelHeader: {
      paddingBlockStart: token.paddingSM,
      paddingInline: token.paddingSM
    },

    tooltipTrigger: {
      display: 'inline-flex'
    },

    overflowMenu: {
      minWidth: OVERFLOW_MENU_MIN_WIDTH
    },

    overflowTrigger: {
      display: 'flex',
      width: '100%'
    },

    overflowItem: {
      '&&': {
        justifyContent: 'flex-start',
        textAlign: 'start'
      }
    }
  }
})
